import {  
    getFirestore, 
    doc,
    deleteDoc
} from "firebase/firestore";
const removeHealthData = async function(userId, docId) {

    let db = getFirestore();
    let docRef = doc(db, '/wellness_data/' + userId + '/healthdata/' + docId);
    await deleteDoc(docRef);

};

export default removeHealthData;
